var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialIns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 41,
    viewBox: "0 0 37 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7222 0H10.2778C3.08333 0 0 4.1 0 10.25V30.75C0 36.9 3.08333 41 10.2778 41H26.7222C33.9167 41 37 36.9 37 30.75V10.25C37 4.1 33.9167 0 26.7222 0ZM10.2778 21.0125H18.5C19.3428 21.0125 20.0417 21.7095 20.0417 22.55C20.0417 23.3905 19.3428 24.0875 18.5 24.0875H10.2778C9.435 24.0875 8.73611 23.3905 8.73611 22.55C8.73611 21.7095 9.435 21.0125 10.2778 21.0125ZM26.7222 32.2875H10.2778C9.435 32.2875 8.73611 31.5905 8.73611 30.75C8.73611 29.9095 9.435 29.2125 10.2778 29.2125H26.7222C27.565 29.2125 28.2639 29.9095 28.2639 30.75C28.2639 31.5905 27.565 32.2875 26.7222 32.2875ZM31.8611 14.8625H27.75C24.6256 14.8625 22.0972 12.341 22.0972 9.225V5.125C22.0972 4.2845 22.7961 3.5875 23.6389 3.5875C24.4817 3.5875 25.1806 4.2845 25.1806 5.125V9.225C25.1806 10.6395 26.3317 11.7875 27.75 11.7875H31.8611C32.7039 11.7875 33.4028 12.4845 33.4028 13.325C33.4028 14.1655 32.7039 14.8625 31.8611 14.8625Z",
    fill: "#CBC9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialIns);
export default __webpack_public_path__ + "static/media/specialIns.02f2cbff7af3635507f55d30e80657a2.svg";
export { ForwardRef as ReactComponent };